const ERR_ZIPCODE = 1;
const ERR_STREET_NR = 2;

export {
  ERR_ZIPCODE,
  ERR_STREET_NR,
};

export default {
  methods: {
    emptyHiddenFields(container) {
      document.querySelector(`${container} .streetFormatted`).value = '';
      document.querySelector(`${container} .streetNumber`).value = '';
      document.querySelector(`${container} .street`).value = '';
      document.querySelector(`${container} .region`).value = '';
      document.querySelector(`${container} .city`).value = '';
      document.querySelector(`${container} .zipCode`).value = '';
      document.querySelector(`${container} .latitude`).value = '';
      document.querySelector(`${container} .longitude`).value = '';
    },
    resetFields(container, address) {
      this.emptyHiddenFields(container);
      Object.keys(address).forEach((fieldName) => {
        // eslint-disable-next-line no-param-reassign
        address[fieldName] = '';
      });
    },
    /**
     * Returns 0 if there are no errors
     *         1,2 (the type of the error) if any
     *
     * @param {*} place
     *
     * @return int
     */
    checkPlace(place) {
      let hasZipCode = false;
      let hasRoute = false;
      let hasStreetNumber = false;
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (addressType === 'postal_code') {
          hasZipCode = true;
        }
        if (addressType === 'route') {
          hasRoute = true;
        }
        if (addressType === 'street_number') {
          hasStreetNumber = true;
        }
      }

      // 1st check : must have a zip code
      if (!hasZipCode) {
        return ERR_ZIPCODE;
      }

      // 2nd check : must have a street number if we've got a street
      const addressIsComplete = (hasRoute && hasStreetNumber) || !hasRoute;
      if (!addressIsComplete) {
        return ERR_STREET_NR;
      }

      return 0;
    },
    /**
     *
     * @param {*} place
     * @param {*} address
     */
    setAddressFromPlace(place) {
      const address = {};
      address.name = place.name;
      address.lat = place.location.latitude;
      address.lng = place.location.longitude;

      const fields = {
        country: 'short_name',
      };

      // Get each component of the address from the place details
      // and fill the corresponding field on the form.
      // We consider long_name by default
      place.address_components.forEach((item) => {
        item.types.forEach((type) => {
          const nameType = fields[type] || 'long_name';
          address[type] = item[nameType];
        });
      });

      return address;
    },
    mapPlaceToEntity(place, address) {
      return {
        id: address.id > 0 ? address.id : null,
        countryCode: place.country,
        number: place.street_number || '',
        street: place.route || '',
        region: place.administrative_area_level_1,
        city: place.locality ?? place.administrative_area_level_2,
        zipCode: place.postal_code,
        latitude: place.lat,
        longitude: place.lng,
      };
    },
    mapEntityToPlace(address) {
      let name = '';
      if (address.street) {
        name = `${address.number} ${address.street} ${address.zip_code} ${address.city}`;
      } else if (address.city) {
        // in some cases, we accept "lieu-dit" for which there is no street, nor number
        name = `${address.zip_code} ${address.city}`;
      }

      return {
        id: address.id > 0 ? address.id : null,
        name,
        alias: address.name,
        country: address.country_code,
        postal_code: address.zip_code,
        route: address.street,
        street_number: address.number,
        locality: address.city,
        lat: address.latitude,
        lng: address.longitude,
        administrative_area_level_1: address.region,
      };
    },
  },
};
